import { render, staticRenderFns } from "./pdf-page.vue?vue&type=template&id=587ee230&scoped=true&"
import script from "./pdf-page.ts?vue&type=script&lang=ts&"
export * from "./pdf-page.ts?vue&type=script&lang=ts&"
import style0 from "./pdf-page.scss?vue&type=style&index=0&id=587ee230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ee230",
  null
  
)

export default component.exports